import TextboxSearch from "../../../components/common/TextboxSearch";
import TableControls from "../../../components/common/TableControls";
import { IoClose } from "react-icons/io5";

const CorsHeader = ({ settings, options, onSearch, onChange, setFilter }) => {
  const handleRemoveFilter = (item) => {
    const new_options = { ...options };

    if (item === 1) new_options["rdo"] = "";
    if (item === 2) new_options["status"] = "";
    if (item === 3) {
      new_options["cor"] = "";
      new_options["show"] = "";
    }

    onChange(new_options);
  };

  return (
    <>
      <div className="block lg:flex justify-between items-center">
        <div>
          <p className="text-gray-500 text-sm">Summary</p>
          <span className="text-gray-400 text-xs">
            Certificate of Registrations
          </span>
        </div>
        <div className="mt-5 lg:mt-0 block md:flex md:space-x-2">
          <TextboxSearch placeholder="Search..." onSearch={onSearch} />
          <TableControls onFilter={() => setFilter(true)} settings={settings} />
        </div>
      </div>
      <div className="mt-2 float-right">
        <div className="flex gap-2">
          {options.rdo && (
            <div className="py-1 px-2 flex items-center rounded bg-gray-100 text-gray-500 text-xs">
              RDO: {options.rdo}
              <IoClose
                className="ml-2 cursor-pointer hover:text-red-500"
                onClick={() => handleRemoveFilter(1)}
              />
            </div>
          )}
          {options.status && (
            <div className="py-1 px-2 flex items-center rounded bg-gray-100 text-gray-500 text-xs">
              Status: {options.status}{" "}
              <IoClose
                className="ml-2 cursor-pointer hover:text-red-500"
                onClick={() => handleRemoveFilter(2)}
              />
            </div>
          )}
          {options.show && (
            <div className="py-1 px-2 flex items-center rounded bg-gray-100 text-gray-500 text-xs">
              Show: {options.show}{" "}
              <IoClose
                className="ml-2 cursor-pointer hover:text-red-500"
                onClick={() => handleRemoveFilter(3)}
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default CorsHeader;
